import React from 'react'
import backBtnMobile from "../../../assets/backBtnMobile.png";
import { Route, Routes, Link, BrowserRouter } from "react-router-dom";
import aboutAnantContent from "../../../assets/aboutAnantContentImage.png"

import mobileCelebrityImage from "../../../assets/anant-mobile.png";

import "./aboutAnant.css"

const AboutAnant = () => {
  return (
    <div className="mb-about-container">
    <div className="mb-about-topContainer">
    <Link to={'/'}> <img src={backBtnMobile} className="backBtnMobile" /></Link>
      <div className="mb-aboutHeading">
      ABOUT 
 <br /> ANANT LADHA
      </div>
    </div>

    <div className="mb-about-contentContainer">
      <img src={mobileCelebrityImage} className="mb-celebrityImage" />

      <div className="mb-about-content-container">
          <div className='profileOfAnantHeading-mb'>PROFILE OF ANANT LADHA
</div>
            <img src={aboutAnantContent} className='aboutAnantContentImage'/>
      </div>
    </div>
  </div>  
  )
}

export default AboutAnant